import "./Plans.modules.css";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
//components
import Modal from "../../../components/modal/Modal";
import CardPlan from "../../../components/cards/CardPlan";
import CarouselPlans from "../../../components/Carousel/CarouselPlans";
//services
import { getPlans } from "../../../services/CreateAccount/getPlans";
import { useCreateAccountContext } from "../../../context/CreateAccountContext";

const Plans = () => {
  const [searchParams] = useSearchParams();
  const isFreePlan = searchParams.get("freeplan") === "true";
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [baseData, setBaseData] = useState(null);
  const [sortedData, setSortedData] = useState(null);
  const [selectedInterval, setSelectedInterval] = useState(null);

  const { savePlan, handleFreeSubmit } = useCreateAccountContext();

  const { data, isLoading } = useQuery({
    queryKey: ["plans"],
    queryFn: () => getPlans(),
  });

  const handleSelect = (data) => {
    //    console.log(data)
    const sortedIntervals = data.intervals.sort((a, b) => {
      if (a.interval === "month" && b.interval === "year") return -1;
      if (a.interval === "year" && b.interval === "month") return 1;
      if (a.interval === "month" && b.interval === "month")
        return a.interval_count - b.interval_count;
      if (a.interval === "year" && b.interval === "year")
        return a.interval_count - b.interval_count;
      return 0;
    });

    let maxYearInterval = null;

    sortedIntervals.forEach((interval) => {
      if (interval.interval === "year") {
        if (
          !maxYearInterval ||
          interval.interval_count > maxYearInterval.interval_count
        ) {
          maxYearInterval = interval;
        }
      }
    });

    if (maxYearInterval) {
      maxYearInterval.isLongestYearInterval = true;
    }

    data.intervals = sortedIntervals;

    setBaseData(data);
    setVisible(true);
  };

  const handleClickInterval = async (interval) => {
    setSelectedInterval(interval);
    setLoading(true);
    //    console.log(interval)
    await savePlan({
      plan: baseData,
      interval: interval,
    });
    setVisible(false);
    setLoading(false);
  };

  const handleFreeInterval = async (interval) => {
    setSelectedInterval(interval);
    setLoading(true);
    //    console.log(interval)
    await handleFreeSubmit({
      plan: baseData,
      interval: interval,
    });
    setVisible(false);
    setLoading(false);
  };

  const handleClose = () => {
    setBaseData();
    setVisible(false);
  };

  useEffect(() => {
    const sortPlans = (plans) => {
      return plans.sort((a, b) => (b.highlighted === 1 ? 1 : -1));
    };

    setSortedData(data ? { ...data, plans: sortPlans(data.plans) } : data);
  }, [data]);

  return (
    <>
      {isLoading ? (
        <div className="row gx-4 py-3" data-bs-theme="dark">
          <div className={`col-xl-3 col-md-6 py-3 h-100`}>
            <Skeleton width="100%" height={400} />
          </div>
          <div className={`col-xl-3 col-md-6 py-3 h-100`}>
            <Skeleton width="100%" height={400} />
          </div>
          <div className={`col-xl-3 col-md-6 py-3 h-100`}>
            <Skeleton width="100%" height={400} />
          </div>
          <div className={`col-xl-3 col-md-6 py-3 h-100`}>
            <Skeleton width="100%" height={400} />
          </div>
        </div>
      ) : (
        <>
          {sortedData?.plans.length > 4 ? (
            <CarouselPlans
              data={data}
              savePlan={savePlan}
              options={{ loop: true }}
              handleSelect={handleSelect}
              quantity={sortedData?.plans.length}
            />
          ) : (
            <div className="row py-3" data-bs-theme="dark">
              {sortedData?.plans?.map((plan) => {
                if (plan.free_trial_days) {
                  if (isFreePlan) {
                    return (
                      <CardPlan
                        plan={plan}
                        savePlan={savePlan}
                        handleSelect={handleSelect}
                        modules={sortedData?.modules}
                        quantity={sortedData?.plans.length}
                      />
                    );
                  } else {
                    return null;
                  }
                } else {
                  return (
                    <CardPlan
                      plan={plan}
                      savePlan={savePlan}
                      handleSelect={handleSelect}
                      modules={sortedData?.modules}
                      quantity={sortedData?.plans.length}
                    />
                  );
                }
              })}
            </div>
          )}
          <Modal
            visible={visible}
            dynamicTitle="Opções do Plano"
            onHide={() => !loading && handleClose()}
            closable={true}
          >
            <div className="row">
              {baseData &&
                baseData.intervals.map((i, index) => (
                  <div
                    key={index}
                    className={`col-xl-6 col-md-6 py-3 pricing-card`}
                    // className={`col-xl-3 col-md-6 py-3 h-100 pricing-card ${
                    //   plan.highlighted === 0 ? "py-xl-5" : ""
                    // }`}
                  >
                    <div
                      className={`card bg-dark-400 border-0 rounded-4 h-100`}
                      style={
                        i.isLongestYearInterval
                          ? {
                              background:
                                "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(0,185,167,1) 0%, rgba(114,212,202,1) 100%)",
                              overflow: "hidden",
                            }
                          : {}
                      }
                    >
                      <div className="card-body fs-14px p-30px d-flex flex-column position-relative">
                        {/* {!user && plan.highlighted === 1 && (
                        <div className="ribbon">Mais Vendido!</div>
                      )} */}
                        <div className="d-flex align-items-center">
                          <div className="flex-1">
                            <div className="h5 text-white font-monospace">
                              {i.name}
                            </div>
                            {i.pivot.discount_rate > 0 ? (
                              <div className="d-flex align-items-center">
                                <small className="h5 mt-2 text-gray-100 text-opacity-50">
                                  <s>R$ {baseData.value_total}</s>
                                </small>
                                <div className="bg-white rounded-pill fw-bold py-1 px-3 mx-2">
                                  Economize {i.pivot.discount_rate * 100}%
                                </div>
                              </div>
                            ) : (
                              <div className="d-flex align-items-center">
                                <small
                                  className="h5 mt-2 text-gray-100 text-opacity-0"
                                  style={{ visibility: "hidden" }}
                                >
                                  <s>R$ {baseData.value_total}</s>
                                </small>
                                <div
                                  className="bg-white rounded-pill fw-bold py-1 px-3 mx-2"
                                  style={{ visibility: "hidden" }}
                                >
                                  Economize 0%
                                </div>
                              </div>
                            )}
                            <div className="display-6 text-white fw-bold mb-0">
                              {baseData.free_trial_days ? (
                                <>
                                  GRÁTIS{" "}
                                  <small className="h5 text-gray-100 text-opacity-50">
                                    por {baseData.free_trial_days} dias
                                  </small>
                                </>
                              ) : (
                                <>
                                  R${" "}
                                  {baseData.value_total -
                                    baseData.value_total *
                                      i.pivot.discount_rate}{" "}
                                  <small className="h5 text-gray-100 text-opacity-50">
                                    /mês*
                                  </small>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="mx-n2 mt-3">
                          <Button
                            label="Assinar"
                            disabled={loading}
                            onClick={() =>
                              baseData.free_trial_days
                                ? handleFreeInterval(i)
                                : handleClickInterval(i)
                            }
                            loading={i.id === selectedInterval?.id && loading}
                            className="w-100 text-black border border-0 button-card"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default Plans;
